const FORM_CLASS_PREFIX = 'klaviyo-form-';

/**
 * @param {HTMLElement} root
 * @param {string} id
 * @returns {HTMLElement | null}
 */
function findFormRoot(root, id) {
  const trimmed = (id || '').trim();
  if (!trimmed) return null;
  const byClass = root.querySelector(`.${FORM_CLASS_PREFIX}${trimmed}`);
  if (byClass) return byClass;
  return root.querySelector(`#${FORM_CLASS_PREFIX}${trimmed}`);
}

/**
 * @param {HTMLElement} root
 */
function sync(root) {
  const emailId = root.dataset.klaviyoFormIdEmail || '';
  const smsId = root.dataset.klaviyoFormIdSms || '';
  const active = root.dataset.activeTab === 'sms' ? 'sms' : 'email';

  const emailEl = findFormRoot(root, emailId);
  const smsEl = findFormRoot(root, smsId);

  if (emailEl) {
    const show = active === 'email';
    emailEl.toggleAttribute('hidden', !show);
    emailEl.setAttribute('aria-hidden', show ? 'false' : 'true');
  }

  if (smsEl) {
    const show = active === 'sms';
    smsEl.toggleAttribute('hidden', !show);
    smsEl.setAttribute('aria-hidden', show ? 'false' : 'true');
  }

  root.querySelectorAll('[data-forms-group-tab]').forEach((btn) => {
    const tab = btn.dataset.formsGroupTab;
    const isOn = tab === active;
    btn.classList.toggle('is-active', isOn);
    btn.setAttribute('aria-selected', isOn ? 'true' : 'false');
  });

  const panel = root.querySelector('.footer-forms-group__content[role="tabpanel"]');
  const activeBtn = root.querySelector('[data-forms-group-tab].is-active');
  if (panel && activeBtn?.id) {
    panel.setAttribute('aria-labelledby', activeBtn.id);
  }
}

class FooterFormsGroup extends HTMLElement {
  connectedCallback() {
    this._onClick = this._onClick.bind(this);
    this.addEventListener('click', this._onClick);
    sync(this);
    this._observer = new MutationObserver(() => sync(this));
    this._observer.observe(this, { childList: true, subtree: true });
  }

  disconnectedCallback() {
    this.removeEventListener('click', this._onClick);
    this._observer?.disconnect();
  }

  /**
   * @param {MouseEvent} e
   */
  _onClick(e) {
    const btn = e.target.closest('[data-forms-group-tab]');
    if (!btn || !this.contains(btn)) return;
    const tab = btn.dataset.formsGroupTab;
    if (tab !== 'email' && tab !== 'sms') return;
    this.dataset.activeTab = tab;
    sync(this);
  }
}

if (!customElements.get('footer-forms-group')) {
  customElements.define('footer-forms-group', FooterFormsGroup);
}
